// extracted by mini-css-extract-plugin
export default {"reset-password":"ResetPassword_reset-password__rch22","actions":"ResetPassword_actions__FrFL+"};